/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var GoogleTranslate = /** @class */ (function () {
        function GoogleTranslate() {
            this.EL_NAME = 'google_translate_element';
            this.CALLBACK = 'extGoogleTranslateLoad';
            this.element = document.getElementById(this.EL_NAME);
            this.langs = 'en';
            this.autoDisplay = false;
            this.targetElementDesktop = 'header > .contentWrap';
            this.targetElementMobile = '';
        }
        GoogleTranslate.init = function () {
            new GoogleTranslate().run();
        };
        GoogleTranslate.prototype.run = function () {
            if (!this.element) {
                return;
            }
            this.initSettings();
            this.initExternalJs();
        };
        GoogleTranslate.prototype.initSettings = function () {
            if (this.element.dataset.langs) {
                this.langs = this.element.dataset.langs;
            }
            if (this.element.dataset.auto_display) {
                this.autoDisplay = true;
            }
            if (this.element.dataset.target_desktop) {
                this.targetElementDesktop = this.element.dataset.target_desktop;
            }
            if (this.element.dataset.target_mobile) {
                this.targetElementMobile = this.element.dataset.target_mobile;
            }
        };
        GoogleTranslate.prototype.initExternalJs = function () {
            var url = 'https://translate.google.com/translate_a/element.js';
            var el = document.createElement('script');
            el.setAttribute('type', 'text/javascript');
            el.setAttribute('src', url + '?cb=' + this.CALLBACK);
            this.createOnLoadCallback();
            document.getElementsByTagName('head')[0].appendChild(el);
        };
        GoogleTranslate.prototype.createOnLoadCallback = function () {
            var _this = this;
            window[this.CALLBACK] = function () {
                var isDesktop = document.body.clientWidth + 15 >= 992;
                _this.element.setAttribute('class', (isDesktop ? 'hidden-sm hidden-xs' : 'hidden-lg hidden-md'));
                var targetSelector = isDesktop ? _this.targetElementDesktop : _this.targetElementMobile;
                var target = document.querySelector(targetSelector);
                if (!target) {
                    return;
                }
                target.appendChild(_this.element);
                new google.translate.TranslateElement({
                    pageLanguage: document.documentElement.lang,
                    includedLanguages: _this.langs,
                    layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
                    autoDisplay: _this.autoDisplay,
                }, _this.EL_NAME);
            };
        };
        return GoogleTranslate;
    }());

    GoogleTranslate.init();

}());
typeof tsBuild === 'function' && tsBuild();})();
